export default __webpack_public_path__ + "static/media/imgg.6cea001f.JPG";